export default {
  'form.advancedform.basic.title': 'Advanced Form',
};
